import { TThunkAction } from '../../types/redux';
import {
  fetchSendFormAnalytics,
  ISendFormAnalyticsResponse200,
  ISendFormAnalyticsResponse400,
  ISendFormAnalyticsRequest,
} from '../../repositories/lead-realtor-form/v1/send-form-analytics';

export const sendFormAnalytics = (parameters: ISendFormAnalyticsRequest): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      await fetchSendFormAnalytics<ISendFormAnalyticsResponse200, ISendFormAnalyticsResponse400>({
        httpApi,
        parameters,
      });
    } catch (error) {
      logger.error(error, {
        domain: 'sendFormAnalytics.ts',
      });
    }
  };
};
